interface IbankingInfo {
  companyName?: string;
  bic?: string;
  iban?: string;
  rib?: string;
}
export interface ISellingPointInfoBanking {
  bankingInfo: IbankingInfo;
  productCode?: string;
  sellingPointCode?: string;
}

export class SellingPoint {
  bankingInfo: IbankingInfo;
  productCode?: string;
  sellingPointCode?: string;
}

export const defaultValue: Readonly<ISellingPointInfoBanking> = {
  bankingInfo: {},
  productCode: '',
  sellingPointCode: '',
};
